import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccessibilitySkipLinks',
  emits: ['trigger-search'],
  setup(__props, { emit }) {

const accessibilityStatementLink = computed<INavigationViewObject | null>(() => store.getters['app/accessibilityStatementUrl']);


const focusableSelectors = [
    'a[href]',
    'area[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'iframe',
    '[tabindex]:not([tabindex="-1"])',
    '[contenteditable]'
].join(',');

function focusFirstElementInMain() {  
    const main = document.querySelector('main');
    if (!main) return;
    const focusableElements = Array.from(main.querySelectorAll(focusableSelectors)) as HTMLElement[];

    for (const element of focusableElements) {
        element.focus();

        // Check if the element actually received focus
        // Needed to handle cases when next element to focus is not visible and so not focusable (i.e. product pages with the previous slide button)
        if (document.activeElement === element) {
            return; // Success: stop trying
        }
    }
}


function handleSkipToSearch() {
    emit('trigger-search');
}

return { __sfc: true,accessibilityStatementLink, emit, focusableSelectors, focusFirstElementInMain, handleSkipToSearch }
}

})